import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import NotificaionGui from "../masterLayout/NotificaionGui"
import ChangePasswordModal from "../components/comprobantes/ChangePasswordMenuAndModal";
import PortalLogo from "../components/utils/PortalLogo";

const MasterLayout = ({ children }) => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);

  let [cambioPassModal, setCambioPassModal] = useState(false);

  const [user, setUser] = useState('');
  const [strRoles, setStrRoles] = useState('');
  const [idUser, setIdUser] = useState('');



  const location = useLocation(); // Hook to get the current route
  useEffect(() => {

    setUser(localStorage.getItem('user'))
    setStrRoles(localStorage.getItem('roles'))
    setIdUser(localStorage.getItem('idUser'))

  }, []);

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };




    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };




    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);


  function hasRole(roleToFind) {
    return strRoles.includes(roleToFind);
  }

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
              ? "sidebar sidebar-open"
              : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type='button'
          className='sidebar-close-btn'
        >
          <Icon icon='radix-icons:cross-2' />
        </button>
        <div>
          <Link to='/index-9' className='sidebar-logo'>
            <PortalLogo className='light-logo' />



            <h6
              className="text-primary-600 mb-2"
              style={{
                marginLeft: 10,
                display: sidebarActive ? 'none' : 'block',
              }}
            >
              Portal<br />Trabajador
            </h6>

            <img
              src='assets/images/logo-light.png'
              alt='site logo'
              className='dark-logo'
            />
            <img
              src='assets/images/logo-icon.png'
              alt='site logo'
              className='logo-icon'
            />
          </Link>

        </div>
        <div className='sidebar-menu-area'>
          <ul className='sidebar-menu' id='sidebar-menu'>

            <li className='sidebar-menu-group-title'>Inicio</li>
            <li>
              <NavLink
                to='/index-9'
                className={(navData) => (navData.isActive ? "active-page" : "")}>
                <Icon icon='solar:home-smile-angle-outline' className='menu-icon' />
                <span>Dashboard</span>
              </NavLink>
            </li>

            {hasRole('ADMINISTRADOR') &&
              <>
                <li className='sidebar-menu-group-title'>Administración</li>
                <li>
                  <NavLink
                    to='/usuarios'
                    className={(navData) => (navData.isActive ? "active-page" : "")}
                  >
                    <Icon icon='mage:user' className='menu-icon' />
                    <span>Usuarios</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to='/theme'
                    className={(navData) => (navData.isActive ? "active-page" : "")} >
                    <Icon icon="solar:palette-bold" className="menu-icon" />
                    <span>Thema</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to='/notificaciones'
                    className={(navData) => (navData.isActive ? "active-page" : "")}
                  >
                    <Icon icon='iconoir:bell' className='menu-icon' />
                    <span>Notificaciones</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to='/autorizaciones'
                    className={(navData) => (navData.isActive ? "active-page" : "")}
                  >
                    <Icon icon='solar:lock-password-outline' className='menu-icon' />
                    <span>Autorización</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to='/sincronizacion'
                    className={(navData) => (navData.isActive ? "active-page" : "")} >
                    <Icon icon="solar:refresh-outline" className="menu-icon" />
                    <span>Sincronización</span>
                  </NavLink>
                </li>

              </>
            }

            {(hasRole('ADMINISTRADOR') || hasRole('CONSULTA')) &&
              <>
                <li>
                  <NavLink
                    to='/admin/consultas'
                    className={(navData) => (navData.isActive ? "active-page" : "")} >
                    <Icon icon='solar:document-text-outline' className='menu-icon' />
                    <span>Consultas Administrador</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to='/comprobantesAdmin'
                    className={(navData) => (navData.isActive ? "active-page" : "")} >
                    <Icon icon='solar:document-text-outline' className='menu-icon' />
                    <span>CFDIS Administrador</span>
                  </NavLink>
                </li>
              </>
            }

            {hasRole('DELEGADO') &&
              <>
                <li className='sidebar-menu-group-title'>Delegado</li>
                <li>
                  <NavLink
                    to='/comprobantesDelegado'
                    className={(navData) => (navData.isActive ? "active-page" : "")} >
                    <Icon icon='solar:document-text-outline' className='menu-icon' />
                    <span>CFDIS Delegados</span>
                  </NavLink>
                </li>
              </>
            }

            {(hasRole('ADMINISTRADOR') || hasRole('TRABAJADOR')) &&
              <>

              <li className='sidebar-menu-group-title'>Comprobantes</li>
              
                <li>
                  <NavLink
                    to='/consultas'
                    className={(navData) => (navData.isActive ? "active-page" : "")} >
                    <Icon icon='solar:document-text-outline' className='menu-icon' />
                    <span>Consultas </span>
                  </NavLink>
                </li>

                
                <li>
                  <NavLink
                    to='/comprobantes'
                    className={(navData) => (navData.isActive ? "active-page" : "")} >
                    <Icon icon='solar:document-text-outline' className='menu-icon' />
                    <span>CFDIS</span>
                  </NavLink>
                </li>
              </>
            }
            {/* todos */}
            <>
              <li className='sidebar-menu-group-title'>Peticiones de descargas</li>
              <li>
                <NavLink
                  to='/descargas'
                  className={(navData) => (navData.isActive ? "active-page" : "")} >
                  <Icon icon='solar:cloud-download-outline' className='menu-icon' />
                  <span>Descargas</span>
                </NavLink>
              </li>
            </>


          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className='navbar-header'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-4'>
                <button
                  type='button'
                  className='sidebar-toggle'
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon='iconoir:arrow-right'
                      className='icon text-2xl non-active'
                    />
                  ) : (
                    <Icon
                      icon='heroicons:bars-3-solid'
                      className='icon text-2xl non-active '
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type='button'
                  className='sidebar-mobile-toggle'
                >
                  <Icon icon='heroicons:bars-3-solid' className='icon' />
                </button>
                {/* 
                <form className='navbar-search  bg-neutral  '>
                  <input className=" bg-neutral " type='text' name='search' placeholder='Buscar' />
                  <Icon icon='ion:search-outline' className='icon' />
                </form>
                    */}
              </div>
            </div>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-3'>
                {/* ThemeToggleButton 
                <ThemeToggleButton />*/}

                {/* Language dropdown end */}

                {/* Message dropdown end */}
                <NotificaionGui />
                {/*
                <div className='dropdown'>
                  <button
                    className='has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center'
                    type='button'
                    data-bs-toggle='dropdown'
                  >
                    <Icon
                      icon='iconoir:bell'
                      className='text-primary-light text-xl'
                    />
                  </button>
                  <div className='dropdown-menu to-top dropdown-menu-lg p-0'>
                    <div className='m-16 py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-neutral-50 fw-semibold mb-0'>
                          Notificaciones
                        </h6>
                      </div>
                      <span className='text-primary-600 fw-semibold text-lg w-40-px h-40-px rounded-circle bg-base d-flex justify-content-center align-items-center'>
                        02
                      </span>
                    </div>
                    <div className='max-h-400-px overflow-y-auto scroll-sm pe-4'>
                      <Link
                        to='#'
                        className='px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between'
                      >
                        <div className='text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'>
                          <span className='w-44-px h-44-px bg-success-subtle text-success-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0'>
                            <Icon
                              icon='bitcoin-icons:verify-outline'
                              className='icon text-xxl'
                            />
                          </span>
                          <div>
                            <h6 className='text-md fw-semibold mb-4'>
                              Nueva factura disponible
                            </h6>
                            <p className='mb-0 text-sm text-secondary-light text-w-200-px'>
                              Disponible para su descarga CFDI pago 30 Junio del 2025
                            </p>
                          </div>
                        </div>
                        <span className='text-sm text-secondary-light flex-shrink-0'>
                          1 ayer
                        </span>
                      </Link>
                      <Link
                        to='#'
                        className='px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between bg-neutral-50'
                      >
                        <div className='text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'>
                          <span className='w-44-px h-44-px bg-success-subtle text-success-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0'>
                            <img
                              src='assets/images/notification/profile-1.png'
                              alt=''
                            />
                          </span>
                          <div>
                            <h6 className='text-md fw-semibold mb-4'>
                              Festival de dia de las Madres
                            </h6>
                            <p className='mb-0 text-sm text-secondary-light text-w-200-px'>
                              Asiste .......
                            </p>
                          </div>
                        </div>
                        <span className='text-sm text-secondary-light flex-shrink-0'>
                          10 dias atrás
                        </span>
                      </Link>

                    </div>

                    <div className='text-center py-12 px-16'>
                      {/*
                      <Link
                        to='#'
                        className='text-primary-600 fw-semibold text-md'
                      >
                        See All Notification
                        
                      </Link>* /}
                    </div>
                  </div>
                </div>
                */}
                {/* Notification dropdown end */}
                <div className='dropdown'>
                  <button
                    className='d-flex justify-content-center align-items-center rounded-circle'
                    type='button'
                    data-bs-toggle='dropdown'
                  >
                    <img
                      src='assets/images/user.png'
                      alt='image_user'
                      className='w-40-px h-40-px object-fit-cover rounded-circle'
                    />
                  </button>
                  <div className='dropdown-menu to-top dropdown-menu-sm'>
                    <div className='py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-neutral-50 fw-semibold mb-2'>
                          {user}
                        </h6>
                        <span className='text-neutral-50 fw-medium text-sm'>
                          {strRoles}
                        </span>
                      </div>
                      <button type='button' className='hover-text-danger'>
                        <Icon
                          icon='radix-icons:cross-1'
                          className='icon text-xl'
                        />
                      </button>
                    </div>
                    <ul className='to-top-list'>

                      {/* 
                      <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'
                          to='/view-profile'
                        >
                          <Icon
                            icon='solar:user-linear'
                            className='icon text-xl'
                          />{" "}
                          Mi Perfil
                        </Link>
                      </li>
                        */}
                      <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3'
                          onClick={() => setCambioPassModal(true)}
                        >
                          <Icon icon='lucide:key' className='icon text-xl' />{" "}
                          Cambiar contraseña
                        </Link>
                      </li>
                      <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3'
                          to='/'
                        >
                          <Icon icon='lucide:power' className='icon text-xl' />{" "}
                          Salir
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className='dashboard-main-body'>{children}</div>

        <ChangePasswordModal
          showModal={cambioPassModal}
          onClose={() => setCambioPassModal(false)}
          userId={idUser} />

        {/* Footer section */}
        <footer className='d-footer'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <p className='mb-0'>© 2025 Portal del Trabajador.</p>
            </div>

          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
